export default __webpack_public_path__ + "static/media/Hood.ff9784ad.png";